import { atom } from 'recoil';

export const LocationCanBackState = atom({
    key: 'LocationCanBackState',
    default: false
});